import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getConferenceFriendlyName = async (conferenceSid: string) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      conferenceSid,
    },
    query: graphql(`
      query ConferenceFriendlyName($conferenceSid: String!) {
        conferenceFriendlyName(conferenceSid: $conferenceSid)
      }
    `),
  });

  return response.data.conferenceFriendlyName;
};
